  if (!customElements.get('alb-reviews-modal')) {
    customElements.define('alb-reviews-modal', class extends HTMLElement {
      connectedCallback(){
        if (this._init) return;
        // §3.13: Setup erst, wenn die Kinder im DOM sind.
        if (!this.querySelector('.alb-rvm-dialog')) {
          var self = this;
          if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function(){ self._setup(); }, { once: true }); }
          else { requestAnimationFrame(function(){ self._setup(); }); }
          return;
        }
        this._setup();
      }
      _setup(){
        if (this._init) return; this._init = true;
        var self = this;
        this.status = this.querySelector('[data-rvm-status]');
        this.built = false;
        this.lastFocus = null;
        this._onKey = function(e){ if (e.key === 'Escape') self.close(); };
        this.querySelectorAll('[data-rvm-close]').forEach(function(el){ el.addEventListener('click', function(){ self.close(); }); });
        // Trigger (Sterne, Buttons) über aria-controls verknüpfen
        Array.prototype.forEach.call(document.querySelectorAll('[aria-controls="' + this.id + '"]'), function(t){
          t.addEventListener('click', function(e){ e.preventDefault(); self.open(t); });
          t.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.open(t); } });
        });
      }
      open(trigger, opts){
        this.lastFocus = trigger || document.activeElement;
        this.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        document.addEventListener('keydown', this._onKey);
        var c = this.querySelector('.alb-rvm-close'); if (c) c.focus();
        /* Gewuenschter Sterne-Filter ('' = keiner); greift nach dem Widget-Aufbau */
        this.wantRating = (opts && opts.rating) ? String(opts.rating) : '';
        this.loadWidget();
        this.applyRating(0);
      }
      /* Vue-3-Root des Polaris-Widgets (app._instance ist null, deshalb ueber
         __vue_app__._container._vnode.component.proxy — liefert $refs.product_reviews
         mit dispatch/state und trans()). */
      _vueRoot(){
        var box = this.querySelector('.alb-rvm-widget');
        if (!box) return null;
        var nodes = [box].concat(Array.prototype.slice.call(box.querySelectorAll('*')));
        for (var i = 0; i < nodes.length; i++) {
          var app = nodes[i].__vue_app__;
          if (app && app._container && app._container._vnode && app._container._vnode.component) {
            return app._container._vnode.component.proxy;
          }
        }
        return null;
      }
      /* Sterne-Filter setzen/loeschen: 'rating:N' setzt, 'rating:' loescht.
         Der Store existiert erst nach dem Mount -> bis ~5 s pollen. */
      applyRating(tries){
        if (!this.ready) return;
        var want = this.wantRating || '';
        if (want === (this.appliedRating || '')) return;
        var root = this._vueRoot();
        var pr = root && root.$refs && root.$refs.product_reviews;
        if (!pr || typeof pr.dispatch !== 'function') {
          if (tries < 25) { var self = this; window.setTimeout(function(){ self.applyRating(tries + 1); }, 200); }
          return;
        }
        pr.dispatch('toggleQuestionFilter', 'rating:' + want);
        this.appliedRating = want;
      }
      close(){
        this.hidden = true;
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', this._onKey);
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
      }
      loadWidget(){
        if (this.built) return; this.built = true;
        var self = this;
        var store  = this.getAttribute('data-store');
        var sku    = this.getAttribute('data-sku') || '';
        var widget = this.getAttribute('data-widget') || 'polaris';
        var box    = this.querySelector('.alb-rvm-widget');
        if (!box) return;
        var target = '#' + box.id;
        /* Produktname je Bewertung nur, wenn das Popup mehrere Produkte
           umfasst (Startseite: sku leer = shopweit; Collections/Auswahl:
           ';'-Liste). Auf der einzelnen PDP waere er redundant. Der Link
           zeigt auf die Produktseite laut Reviews.io-Katalog (alb-filter.com/
           products/<handle>, im Browser verifiziert 2026-09-03). */
        var multiProduct = !sku || sku.indexOf(';') >= 0;
        function build(){
          try {
            new ReviewsWidget(target, {
              store: store, widget: widget,
              /* styles MUSS gesetzt sein: Polaris liest CSS-Variablen ueber
                 config.styles[...] (cssVar()) und wirft ohne das Objekt bei
                 jeder Foto-Review "Cannot read properties of undefined
                 (reading '--photo-video-thumbnail-size')" — die Bild-
                 Thumbnails der Karten fehlten dann. Sternfarbe hier UND als
                 CSS-Override in alb-base.css (Iconfont-Gradient). */
              styles: {
                '--common-star-color': '#FB9F17',
                '--photo-video-thumbnail-size': '80px'
              },
              options: {
                types: 'product_review',
                lang: 'de',
                per_page: 10,
                /* sku leer = alle Produktbewertungen des Shops (Startseite) */
                product_review: { sku: sku, enable_rich_snippets: false },
                /* Sterne-Filter (im Browser gegen build.js verifiziert):
                   Die Filter-/Sortier-Zeile lebt im Subheader — OHNE
                   header.enable_sub_header rendert sie nie. Darin:
                   "Aufschlüsselung" = klickbare 1-5-Sterne-Zeilen mit Anzahl
                   (enable_overall_rating_filter + show_counts) sowie
                   Sortierung (Neueste/Älteste/Beliebteste/Beste). */
                header: {
                  enable_summary: true,
                  enable_sub_header: true
                },
                filtering: {
                  enable: true,
                  show_counts: true,
                  /* 2026-09-03: Filter nicht mehr im "Sortieren"-Dropdown versteckt,
                     sondern ausgeklappt als Chips (Sortieren nach / Bewertungen
                     mit / Aufschlüsselung) + sichtbarer "Filter löschen"-Button.
                     Ein aktiver Chip wird per erneutem Klick wieder abgewählt
                     (Widget-intern toggleQuestionFilter). */
                  enable_expanded_filters: true,
                  enable_overall_rating_filter: true,
                  /* "Bewertungen mit": Nur-mit-Bildern/Videos-Filter (Polaris
                     conf() defaultet unset auf false — explizit einschalten). */
                  enable_media_filter: true,
                  enable_sorting: true
                },
                /* Linke Spalte der Karten: Name, Verifiziert-Badge (Key lebt im
                   async VerifiedBadge-Chunk!), Stadt ("city, country"-Default)
                   und Datum. Kein Avatar/Gravatar (keine Fremd-Requests). */
                reviews: {
                  enable_product_name: multiProduct,
                  enable_link_product: multiProduct,
                  enable_images: true,
                  enable_reviewer_name: true,
                  enable_reviewer_address: true,
                  enable_date: true,
                  enable_verified_badge: true,
                  verified_badge_position: 'below-name',
                  /* Service-Antworten zeigen, lange einklappen (Beschriftung + Optik s. u.) */
                  enable_replies: true,
                  collapse_replies: true
                },
                questions: { grouping: sku }
              }
            });
            if (self.status) self.status.style.display = 'none';
            enableChipToggle();
            enableReplyLabels();
            self.ready = true;
            self.applyRating(0);
          } catch (e) { if (self.status) self.status.textContent = 'Bewertungen konnten nicht geladen werden.'; }
        }
        /* Abwaehlen per erneutem Klick (2026-09-03): Polaris' Store-Action
           toggleQuestionFilter SETZT einen Filter nur (Name ersetzen, Wert
           pushen) — ein Klick auf den aktiven Chip wiederholt bloss die
           Abfrage. Leerer Wert ("with:" / "rating:") entfernt den Filter.
           Zugriff auf den Store: Vue-3-Prod haelt app._instance = null, aber
           __vue_app__._container._vnode.component.proxy liefert die Root-
           Komponente mit $refs.product_reviews (dispatch/state) und trans().
           Capture-Listener stoppt den Widget-Handler nur fuer aktive Chips in
           "Bewertungen mit" (Heading = trans('Reviews With')) und der Sterne-
           Aufschluesselung (.R-RatingStars im Chip); Sortier-Chips bleiben. */
        function enableChipToggle() {
          function vueRoot() { return self._vueRoot(); }
          function handle(e) {
            if (e.type === 'keyup' && e.key !== 'Enter' && e.key !== ' ') return;
            var chip = e.target.closest('.R-DropUpDownMenu__item.isActive[role="button"]');
            if (!chip || !box.contains(chip)) return;
            var group = chip.closest('.c-filters__dropdown__group');
            if (!group) return;
            var root = vueRoot();
            var pr = root && root.$refs && root.$refs.product_reviews;
            if (!pr || typeof pr.dispatch !== 'function') return;
            var name = '';
            if (chip.querySelector('.R-RatingStars')) {
              name = 'rating';
            } else {
              var head = group.querySelector('.c-dropdown__group__heading');
              var mediaHead = typeof root.trans === 'function' ? root.trans('Reviews With') : 'Bewertungen mit';
              if (head && head.textContent.trim() === String(mediaHead).trim()) { name = 'with'; }
            }
            if (!name) return;
            e.preventDefault(); e.stopPropagation();
            pr.dispatch('toggleQuestionFilter', name + ':');
          }
          box.addEventListener('click', handle, true);
          box.addEventListener('keyup', handle, true);
        }
        /* Service-Antworten: Polaris rendert .RepliesContainer mit Überschrift „Antwort: "
           (trans) und einem fest englischen „Show more"/„Show less"-Button. Der Observer
           setzt beides auf Deutsch — per nodeValue am vorhandenen Textknoten, damit Vue ihn
           beim Umschalten weiter patcht (danach feuert der Observer erneut und übersetzt).
           Polaris klappt ab 2 Zeilen ein, wir kürzen erst nach 3 (Fließtext): passt der Text
           doch in 3 Zeilen, wäre der Link wirkungslos und wird ausgeblendet. */
        function enableReplyLabels() {
          var label = self.getAttribute('data-reply-label') || 'Antwort von Alb Filter';
          function fix() {
            Array.prototype.forEach.call(box.querySelectorAll('.RepliesContainer'), function (rc) {
              var h = rc.querySelector('.R-TextHeading');
              if (h && h.firstChild && h.firstChild.nodeType === 3 && h.firstChild.nodeValue !== label) { h.firstChild.nodeValue = label; }
              var b = rc.querySelector('.R-Button');
              if (b && b.firstChild && b.firstChild.nodeType === 3) {
                var v = b.firstChild.nodeValue;
                var want = /less/i.test(v) ? 'Weniger anzeigen' : (/more/i.test(v) ? 'Mehr lesen' : v);
                if (v !== want) { b.firstChild.nodeValue = want; }
                b.setAttribute('aria-expanded', want === 'Weniger anzeigen' ? 'true' : 'false');
              }
              var t = rc.querySelector('.R-TextBody');
              if (b && t && t.classList.contains('u-textTrim--2')) { b.style.display = (t.scrollHeight > t.clientHeight + 1) ? '' : 'none'; }
            });
          }
          /* Reviews.io-Widget beschriftet den Badge trotz lang:'de' englisch (ClickUp 36) –
             Textknoten "Verified Customer/Buyer" eindeutschen; Schreiben nur bei Abweichung
             (der Observer hört auf characterData, sonst Endlosschleife). */
          var badgeLabel = self.getAttribute('data-verified-label') || 'Verifizierter Käufer';
          function fixBadges() {
            var walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT, null);
            var n; while ((n = walker.nextNode())) {
              if (/^\s*Verified (Customer|Buyer|Purchase)\s*$/i.test(n.nodeValue) && n.nodeValue.trim() !== badgeLabel) { n.nodeValue = badgeLabel; }
            }
          }
          new MutationObserver(function () { fix(); fixBadges(); }).observe(box, { childList: true, subtree: true, characterData: true });
          fix(); fixBadges();
        }
        if (typeof ReviewsWidget !== 'undefined') { build(); return; }
        if (!window.__albReviewsPolarisLoading) {
          window.__albReviewsPolarisLoading = true;
          var sc = document.createElement('script'); sc.src = 'https://widget.reviews.io/polaris/build.js'; sc.async = true; document.head.appendChild(sc);
        }
        var tries = 0;
        (function wait(){
          if (typeof ReviewsWidget !== 'undefined') { build(); return; }
          if (tries++ > 60) { if (self.status) self.status.textContent = 'Bewertungen konnten nicht geladen werden.'; return; }
          window.setTimeout(wait, 200);
        })();
      }
    });
  }
